import React from 'react';
import Translate from 'react-translate-component';
import { Modal } from 'antd';

const WorksheetUnsupported = ({ modal }) => (
    <Modal {...modal} title={<Translate content="worksheet.title" />} footer={null}>
        <Translate content="worksheet.unsupported" unsafe />
    </Modal>
);

export default WorksheetUnsupported;
